import { Disposable } from '../utils';

export interface BitmapTextStyleOpts
{
    fontName: string;
    fontSize?: number;
    align?: string;
    tint?: number;
    letterSpacing?: number;
    maxWidth?: number;
}

export class BitmapTextStyle
{
    private _fontName: string;
    private _fontSize: number;
    private _tint: number;
    private _align: string;
    private _letterSpacing: number;
    private _maxWidth: number;

    private listeners: ((style:BitmapTextStyle)=>void)[];

    constructor(opts: BitmapTextStyleOpts)
    {
        this.listeners = [];
        this._fontName = opts.fontName;
        this._fontSize = opts.fontSize || 24;
        this._tint = opts.tint || 0xffffff;
        this._align = opts.align || 'left';
        this._letterSpacing = opts.letterSpacing || 0;
        this._maxWidth = opts.maxWidth || 0;
    }

    private changed()
    {
        for (let i = this.listeners.length - 1; i >= 0; --i)
        {
            this.listeners[i](this);
        }
    }

    public get fontName() { return this._fontName; }
    public set fontName(font)
    {
        if (font !== this._fontName)
        {
            this._fontName = font;
            this.changed();
        }
    }

    public get fontSize() { return this._fontSize; }
    public set fontSize(size)
    {
        if (size !== this._fontSize)
        {
            this._fontSize = size;
            this.changed();
        }
    }

    public get tint() { return this._tint; }
    public set tint(tint)
    {
        if (tint !== this._tint)
        {
            this._tint = tint;
            this.changed();
        }
    }

    public get align() { return this._align; }
    public set align(align)
    {
        if (align !== this._align)
        {
            this._align = align;
            this.changed();
        }
    }

    public get letterSpacing() { return this._letterSpacing; }
    public set letterSpacing(spacing)
    {
        if (spacing !== this._letterSpacing)
        {
            this._letterSpacing = spacing;
            this.changed();
        }
    }

    public get maxWidth() { return this._maxWidth; }
    public set maxWidth(width)
    {
        if (width !== this._maxWidth)
        {
            this._maxWidth = width;
            this.changed();
        }
    }

    public subscribe(listener:(style:BitmapTextStyle)=>void):Disposable
    {
        this.listeners.push(listener);
        return new Disposable(() => {
            this.unsubscribe(listener);
        });
    }

    public unsubscribe(listener:(style:BitmapTextStyle)=>void):void
    {
        for (let i = this.listeners.length - 1; i >= 0; --i)
        {
            if (this.listeners[i] === listener)
            {
                this.listeners.splice(i, 1);
            }
        }
    }
}